export default __webpack_public_path__ + "beadf9454d22a151f3d7f41f74867eee.png";